/**
 * How a person's name is assembled, in one place.
 *
 * `last_name` is optional (§3.2) — plenty of people in Parinaam's records have
 * one name — so joining the two parts is not quite string concatenation: a naive
 * `first + ' ' + last` leaves a trailing space that then shows up in a search
 * box, a CSV cell, or the middle of a sentence in a warning message.
 *
 * The same rule as `TRIM(CONCAT_WS(' ', first_name, last_name))` in the SQL
 * reads, so a name assembled here and one assembled by the database agree.
 */
export function personName(person) {
    return [person.first_name, person.last_name].filter(Boolean).join(' ').trim();
}
//# sourceMappingURL=names.js.map